export default {
  subCategories: [],
};
